/*
 * @Author: lbh
 * @Date: 2025-10-23 14:41:55
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-23 15:27:09
 * @Description: file content
 */
export default {
  whatsapp: {
    立即参加: "Join Now",
    还差X: "${X} left",
    已满足参加中: "Participating",
    消费满X赠送价值Y现金券: "Spend ${X} and receive a ${Y} cash coupon",
    消费满X赠送Y张ZOFF折扣券: "Spend ${X} and get {Y} {Z}% OFF coupons",
    消费满X获得Y张优惠券: "Spend ${X} and get {Y} coupons",
    立即领取: "Get it now",
    已经领取: "Already received",
    参与中: "Participating",
  },
};
